<template>
  <div>
    <div>
      <v-alert
        v-model="showModalEmergencyMsg"
        type="warning"
        colored-border
        dismissible
        class="alert-message"
      >
        <template #prepend>
          <v-icon class="icon-class">warning</v-icon>
        </template>
        <div class="flex text-white class-title">
          <strong class="">AVISO</strong>
        </div>
        <div class="flex text-white class-text-content">
          {{ messageEmergency }}
        </div>
      </v-alert>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import firebaseService, { EventBus } from "../services/emergencyMessage";

export default {
  data() {
    return {
      messageEmergency: "",
      showModalEmergencyMsg: false,
    };
  },
  ...mapGetters({
    showEmergencyMessage: "events/showEmergencyMessage",
  }),
  created() {
    firebaseService.getEmergencyMsg();

    EventBus.$on("eventBusEmergencyMsg", (value) => {
      if (value.trim().length > 0) {
        this.showModalEmergencyMsg = true;
        this.messageEmergency = value;
      } else {
        this.showModalEmergencyMsg = false;        
        this.messageEmergency = "";
      }
    });    
  },
};
</script>

<style scoped>
.alert-message {
  background-color: orange !important;
}

@media (max-width: 480px) {
  .alertMessage {
    font-size: 10px !important;
  }
}

@media (min-width: 481px) and (max-width: 1024px) {
  .alertMessage {
    font-size: 1.2rem;
  }
}

@media (min-width: 1025px) {
  .alertMessage {
    font-size: 1.4rem;
  }
}

.icon-class {
  color: white !important;
  fill: white !important;
  width: 30px;
}

.class-title {
  margin-left: 15px;
}

.class-text-content {
  margin-left: 15px;
}
</style>
